import { Bar } from 'react-chartjs-2';
import axios from "axios";
import React, { useEffect, useState } from "react";
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';
import { setDate } from 'date-fns';

ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
);

const SalesTeamPerformanceSummary = ({ endpoint }) => {


    const [data, setData] = useState(null)
    let company_code_from_local_storage = localStorage.getItem("companyCode") ? localStorage.getItem("companyCode") : "-"

    const getTodayDate = () => {
        const today = new Date();
        return today.toISOString().split("T")[0];
    };

    const todayDate = getTodayDate();

    const [trendData, setTrendData] = useState([])

    const fetchTrendData = async () => {
        try {
            const response = await axios.get(
                `https://cubixweberp.com:213/api/HRDashboard/${company_code_from_local_storage}/YY/${endpoint}/2024-01-01/${todayDate}/-/-/-/-/-`
            );
            const data = response.data || [];

            console.log("data >>. todays", data)
            setTrendData(data);
        } catch (err) {
            console.error("Error while fetching financial data", err);
        }
    }


    useEffect(() => {
        fetchTrendData()
    }, [])



    useEffect(() => {
        const mappedData = {
            labels: trendData.map((item) => {
                return item.sman_name
            }),
            datasets: [
                {
                    label: 'AvgSaleAmount',
                    backgroundColor: 'rgba(75,192,192,0.6)',
                    borderColor: 'rgba(75,192,192,1)',
                    borderWidth: 1,
                    data: trendData?.map((item) => item.AvgSaleAmount),
                },
                {
                    label: 'SalesCount',
                    backgroundColor: 'rgba(153,102,255,0.6)',
                    borderColor: 'rgba(153,102,255,1)',
                    borderWidth: 1,
                    data: trendData?.map((item) => item.SalesCount),
                },
                {
                    label: 'TotalSales',
                    backgroundColor: '#EF4444',
                    borderColor: '#EF4444',
                    borderWidth: 1,
                    data: trendData?.map((item) => item.TotalSales),
                },
            ],
        };


        setData(mappedData)

    }, [trendData])

    const options = {
        responsive: true,
        plugins: {
            title: {
                display: true,
                text: 'Grouped Bar Chart Example',
            },
        },
        scales: {
            x: {
                stacked: false, // Set to false for grouped bars
            },
            y: {
                beginAtZero: true,
            },
        },
    };

    return (
        <div style={{ width: '600px', height: '400px', overflowY:"scroll" }}>
            {
                data &&
                <Bar data={data} options={options} />
            }
        </div>
    );
};

export default SalesTeamPerformanceSummary;